import { MessageCircle } from "lucide-react";

const PHONE = "918917209551";
const MESSAGE = "Hello Auraa Designs, I'd like to discuss a hospitality uniform consultation.";

export default function WhatsAppFloat() {
  const href = `https://wa.me/${PHONE}?text=${encodeURIComponent(MESSAGE)}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with Auraa Designs on WhatsApp"
      data-testid="whatsapp-float"
      className="group fixed bottom-20 right-5 md:bottom-24 md:right-8 z-[60] flex items-center gap-3 pl-4 pr-5 py-3 bg-[#1E3B2E] text-bone shadow-[0_8px_30px_rgba(30,59,46,0.35)] border border-[#2A5240] hover:bg-[#25503C] transition-all duration-500 hover:translate-y-[-2px]"
    >
      <span className="relative flex items-center justify-center w-7 h-7 rounded-full bg-[#25D366]">
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-40" />
        <svg
          viewBox="0 0 32 32"
          className="relative w-4 h-4 text-white"
          fill="currentColor"
          aria-hidden="true"
        >
          <path d="M19.11 17.16c-.27-.14-1.6-.79-1.85-.88-.25-.09-.43-.14-.61.14-.18.27-.7.88-.86 1.06-.16.18-.32.2-.59.07-.27-.14-1.14-.42-2.17-1.33-.8-.71-1.34-1.59-1.5-1.86-.16-.27-.02-.41.12-.55.13-.13.27-.32.41-.48.14-.16.18-.27.27-.45.09-.18.05-.34-.02-.48-.07-.14-.61-1.47-.84-2.01-.22-.53-.45-.46-.61-.46-.16-.01-.34-.01-.52-.01-.18 0-.48.07-.73.34-.25.27-.95.93-.95 2.27 0 1.34.97 2.63 1.11 2.81.14.18 1.92 2.94 4.66 4.12.65.28 1.16.45 1.56.58.65.21 1.25.18 1.72.11.52-.08 1.6-.65 1.83-1.28.23-.63.23-1.17.16-1.28-.07-.11-.25-.18-.52-.32zM16.02 5.33c-5.9 0-10.7 4.79-10.7 10.7 0 1.88.49 3.71 1.43 5.33L5 27l5.79-1.71c1.56.86 3.32 1.31 5.22 1.31h.01c5.9 0 10.7-4.79 10.7-10.7s-4.81-10.57-10.7-10.57zm0 19.6c-1.7 0-3.36-.46-4.81-1.33l-.34-.2-3.43 1.01 1.03-3.35-.22-.36c-.94-1.5-1.43-3.22-1.43-4.97 0-5.16 4.21-9.37 9.37-9.37 2.5 0 4.86.97 6.63 2.75 1.77 1.77 2.75 4.13 2.75 6.63 0 5.16-4.22 9.36-9.38 9.36z"/>
        </svg>
      </span>
      <span className="hidden sm:flex flex-col leading-tight">
        <span className="text-[9px] uppercase tracking-[0.28em] text-bone/60">WhatsApp</span>
        <span className="text-[12px] tracking-[0.06em] text-bone">Chat with us</span>
      </span>
    </a>
  );
}
